import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-divorced',
  templateUrl: './divorced.component.html',
  styleUrls: ['./divorced.component.scss'],
})
export class DivorcedComponent implements OnInit {
  divorcedProfiles: any[] = [];
  displayMatches: any[] = [];
  base64Images: any = {};
  recommendedMatches: any[] = [];

  loading = true;
  hasPreferences: boolean = true;
  dataList: any[] = [];
  religionList: any[] = [];

  religionMap: any = {};
  cities: any[] = [];
  religions: any[] = [];
  educations: any[] = [];
  occupations: any[] = [];

  favoritedProfileIds = new Set<string>();

  likes = 0;

  newRequests: any[] = [];

  acceptedRequests: any[] = [];

  constructor(
    private apiService: ApiServiceService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.getDivorcedProfiles();
    
  this.checkPartnerPreferences();
    this.getSentConnectionListData();

    // this.getReceivedConnectionListData();

    this.loadFavoritesCount();
    this.loadMasterData();
  }
  goBack(): void {
  this.location.back();
}
  checkPartnerPreferences() {

  const token = localStorage.getItem('sessionToken');
  const profileId = localStorage.getItem('profileId');

  if (!token || !profileId) return;

  this.apiService.getPartnerDetails(token, profileId).subscribe({

    next: (response: any) => {

      if (
        response.status === 'success' &&
        response.data &&
        typeof response.data === 'object' &&
        Object.keys(response.data).length > 0
      ) {

        this.hasPreferences = true;

        this.getDivorcedProfiles();

      } else {

        this.hasPreferences = false;

        this.fetchBasicDivorcedMatches();

      }

    },

    error: () => {

      this.hasPreferences = false;

      this.fetchBasicDivorcedMatches();

    }

  });

}
  fetchBasicDivorcedMatches() {
    const token = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');
    if (!token || !profileId) return;

    this.apiService.getCategoryDiscoveryMatches(token, profileId, 'divorced').subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.divorcedProfiles = res.data || [];
          this.displayMatches = this.divorcedProfiles;
          this.divorcedProfiles.forEach((profile: any) => {
            const idKey = profile.basic_info?.keycloak_id || profile.basic_info?.ory_identity_id || profile._id;
            const avatarId = profile.personal_info?.avatar_Id;
            if (idKey && avatarId) {
              this.loadImage(`${idKey}/gallery/avatar/${avatarId}`, profile._id);
            }
          });
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  getDivorcedProfiles() {
    const token = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');
    if (!token || !profileId) return;

    this.apiService.getCategoryDiscoveryMatches(token, profileId, 'divorced').subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.divorcedProfiles = res.data || [];
          this.displayMatches = this.divorcedProfiles;
          this.divorcedProfiles.forEach((profile: any) => {
            const idKey = profile.basic_info?.keycloak_id || profile.basic_info?.ory_identity_id || profile._id;
            const avatarId = profile.personal_info?.avatar_Id;
            if (idKey && avatarId) {
              this.loadImage(`${idKey}/gallery/avatar/${avatarId}`, profile._id);
            }
          });
        }
        this.loading = false;
      },
      error: (err) => {
        console.log(err);
        this.loading = false;
      }
    });
  }
  loadMasterData() {
    this.apiService.getCity().subscribe((res) => {
      if (res.data) this.cities = res.data;
    });

    this.apiService.getReligions().subscribe((res) => {
      if (res.data) this.religions = res.data;
    });

    this.apiService.getEducation().subscribe((res) => {
      if (res.data) this.educations = res.data;
    });

    this.apiService.getOccupation().subscribe((res) => {
      if (res.data) this.occupations = res.data;
    });
  }
  getSentInterestStatus(profile: any): string | null {
    const req = this.dataList.find(
      (r) => r.selected_profile_id?._id === profile._id,
    );

    return req ? req.interest_status : null;
  }
  triggerInterestAlert(profile: any) {
    if (this.getSentInterestStatus(profile)) return;

    this.sendInterest(profile);
  }

  isFavorited(profileId: string): boolean {
    return this.favoritedProfileIds.has(profileId);
  }
  toggleFavorite(profile: any) {
    const sessionToken = localStorage.getItem('sessionToken');
    const ownerId = localStorage.getItem('profileId');

    if (!sessionToken || !ownerId) return;

    if (this.isFavorited(profile._id)) {
      this.apiService
        .deleteFavorite(sessionToken, profile._id, ownerId)
        .subscribe(() => {
          this.favoritedProfileIds.delete(profile._id);
          this.likes--;
        });
    } else {
      this.apiService
        .addToFavorites(
          sessionToken,
          profile._id,
          ownerId,
          profile.basic_info || {},
          profile.religion_info || {},
        )
        .subscribe(() => {
          this.favoritedProfileIds.add(profile._id);
          this.likes++;
        });
    }
  }
  loadFavoritesCount() {
    const sessionToken = localStorage.getItem('sessionToken');
    const ownerId = localStorage.getItem('profileId');

    if (!sessionToken || !ownerId) return;

    this.apiService.getFavorites(sessionToken, ownerId).subscribe({
      next: (res) => {
        if (res.status === 'success' && Array.isArray(res.data)) {
          this.likes = res.data.length;

          this.favoritedProfileIds = new Set(
            res.data.map((fav: any) => {
              if (typeof fav.profile === 'object' && fav.profile) {
                return fav.profile._id;
              }

              return fav.profile;
            }),
          );
        }
      },

      error: (err) => {
        console.log('Favorite loading error:', err);
      },
    });
  }
  sendInterest(profile: any): void {
    const sessionToken = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');

    if (!sessionToken || !profileId) {
      this.router.navigate(['/login']);
      return;
    }

    this.apiService
      .setConnectionStatus(sessionToken, profileId, profile._id, 'Pending')
      .subscribe({
        next: () => {
          alert(`Interest Sent to ${profile.basic_info.first_name}`);

          this.getSentConnectionListData();
        },

        error: (err) => {
          console.error('Error sending interest', err);
        },
      });
  }
  loadImage(imagePath: string, profileId: string) {
    this.apiService.getImageBase64(imagePath).subscribe({
      next: (data: any) => {
        if (data && data.base64Image) {
          this.base64Images[profileId] = data.base64Image;
        }
      },

      error: (err) => {
        console.log(err);
      },
    });
  }

  getAge(date: string) {
    if (!date) return '';

    const today = new Date();
    const dob = new Date(date);

    return today.getFullYear() - dob.getFullYear();
  }

  getCityName(id: string) {
    if (!id) return '--';

    const city = this.cities.find((c) => c._id === id);

    return city ? city.city_nme : '--';
  }

  getReligionName(id: string) {
    if (!id) return '--';

    const religion = this.religions.find((r) => r._id === id);

    return religion ? religion.religion_nme : '--';
  }

  getEducationName(id: string) {
    if (!id) return '--';

    const education = this.educations.find((e) => e._id === id);

    return education ? education.education_nme : '--';
  }

  getOccupationName(id: any) {
    if (!id) return 'Professional';

    const occupation = this.occupations.find((o) => o._id === id);

    return occupation ? occupation.occupation_nme : 'Professional';
  }
  getPreferenceMatches() {
    const token = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');

    if (!token || !profileId) return;

    this.apiService.getPreferenceFilter(token, profileId).subscribe({
      next: (res: any) => {
        if (res.status === 'success' && Array.isArray(res.data)) {
          this.recommendedMatches = res.data;

          console.log('Preference matches:', this.recommendedMatches);

          this.mergeCompatibility();
        }
      },

      error: (err) => {
        console.log('Preference error:', err);
      },
    });
  }
  mergeCompatibility() {
    this.divorcedProfiles.forEach((profile: any) => {
      const matchedProfile = this.recommendedMatches.find(
        (p: any) => p._id === profile._id,
      );

      if (matchedProfile) {
        profile.preference_fit = matchedProfile.preference_fit;

        profile.similarity_fit = matchedProfile.similarity_fit;

        profile.final_score = matchedProfile.final_score;

        profile.match_badge = matchedProfile.match_badge;
      }
    });
  }
  getCompatibility(profile: any): number {
    console.log(
  "DISPLAY COMPATIBILITY",
  profile.basic_info?.first_name,
  profile.match_badge,
  profile.similarity_fit,
  profile.preference_fit
);

    if (profile.match_badge === 'Similar Match') {
      return Math.round(profile.similarity_fit || 0);
    }

    if (profile.preference_fit !== undefined) {
      return Math.round(profile.preference_fit);
    }

    return 0;
  }
  getSentConnectionListData(): void {
    const sessionToken = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');

    if (!sessionToken || !profileId) return;

    this.apiService.getSentConnectionList(sessionToken, profileId).subscribe({
      next: (response: any) => {
        this.dataList = response.data || [];
      },

      error: (err) => {
        console.error('Error fetching sent connections', err);
      },
    });
  }
}
